var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{class:[
    'transition-input',
    'select-input',
    _vm.value !== null && _vm.value !== void 0 && 'active',
    _vm.disabled && 'disabled',
    _vm.error && 'error',
  ],attrs:{"label":_vm.label,"label-for":_vm.id}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-select',{class:_vm.icon && 'has-icon',attrs:{"id":_vm.id,"options":_vm.selectOptions,"disabled":_vm.disabled,"required":_vm.required,"value":_vm.value},on:{"change":_vm.onChange},nativeOn:{"blur":function($event){return _vm.$emit('blur')}}}),(_vm.icon)?_c('FontIcon',{staticClass:"select-icon",attrs:{"name":_vm.icon}}):_vm._e()],1),_c('InputError',{attrs:{"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }